import React from 'react'
import { Link } from "gatsby";

const Footer = () => {
    return (
        <div className='w-full bg-brand-red pt-16 lg:pt-32 text-white'>
            <div className='lg:max-w-[1440px] mx-auto divide-y divide-[#f8f8f8] divide-opacity-30'>
                <div className='lg:flex justify-between pb-12 px-8 lg:px-16'>
                    <div>
                        <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331997/dochaseadx/pubituebxhlxhnmkybk6.svg' alt='footer logo' loading='eager'/>
                        <p className='mt-4 text-xs lg:text-sm font-normal'>Emerging market leader in Programmatic<br /> Advertising, Ad exchange, DSP and SSP</p>
                        <div className='mt-5 flex space-x-1'>
                            <a href='https://www.instagram.com/hello_dochase/' target='_blank'>
                                <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331779/dochaseadx/zfi9gpb2bfn6ynfhtglu.svg' alt='Instagram logo' loading='eager'/>
                            </a>
                            <a href='https://www.facebook.com/hellodochase' target='_blank'>
                                <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696332089/dochaseadx/jbfllvpq5wjqvqjhnibs.svg' alt='Facebook logo' loading='eager'/>
                            </a>
                            <a href='https://twitter.com/hello_dochase/' target='_blank'>
                                <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331755/dochaseadx/kvxuhdtnzbjbwylae6ld.svg' alt='Twitter logo' loading='eager'/>
                            </a>
                            <a href='https://www.linkedin.com/company/dochase/' target='_blank'>
                                <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331789/dochaseadx/hossegmu05vgedjbzbx0.svg' alt='Linkedin logo' loading='eager'/>
                            </a>
                        </div>
                    </div>

                    <div className='flex flex-col justify-between font-medium mt-8 lg:mt-0'>
                        <div >
                            <p className='font-medium'>SOLUTIONS</p>
                            <ul className='list-disc ml-6 space-y-1'>
                                <li><Link to='/solutions#dsp'>Programmatic Ads (DSP)</Link></li>
                                <li><Link to='/solutions#customer-acquisition'>Customer Acquisition</Link></li>
                                <li><Link to='/solutions#lead-generation'>Lead Generation</Link></li>
                                <li><Link to='/solutions#lead-generation'>App Installation</Link></li>
                                <li><Link to='/solutions#lead-generation'>Website Traffic</Link></li>
                                <li><Link to='/solutions#lead-generation'>Sign Up</Link></li>
                                <li><Link to='/solutions#lead-generation'>Registration</Link></li>
                                <li><Link to='/solutions#customer-engagement'>Customer Engagement</Link></li>
                                <li><Link to='/solutions#retargeting'>Retargeting</Link></li>
                            </ul>
                        </div>
                        <div className='mt-12'>
                            <p className='font-medium'>RESOURCES</p>
                            <ul className='list-disc ml-6 space-y-1'>
                                <li>Publisher Guide</li>
                                <li>Advertiser Guide</li>
                                <li><Link to='/success-stories'>Case Studies</Link></li>
                                <li>Blog</li>
                                <li><Link to='/#form'>Contact Us</Link></li>
                                <li><Link to='/detailed-stories'>Our Clientele</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className='flex flex-col font-medium mt-12 lg:mt-0'>
                        <div>
                            <p className='font-medium'>PRODUCTS</p>
                            <ul className='list-disc ml-6 space-y-1'>
                                <li><Link to='/products#messaging'>Messaging</Link></li>
                                <li><Link to='/products#chatbot'>Chatbot</Link></li>
                                <li><Link to='/products#native-ads'>Native Ads</Link></li>
                                <li><Link to='/products#click-to-whatsapp'>Click to Whatsapp</Link></li>
                                <li><Link to='/products#click-to-ussd'>Click to USSD</Link></li>
                                <li><Link to='/products#video-ads'>Video Ads</Link></li>
                            </ul>
                        </div>
                        <div className='mt-12 lg:mt-[135px]'>
                            <p className='font-medium'>TECHNICAL INFO</p>
                            <ul className='list-disc ml-6 space-y-1'>
                                <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                                <li>Terms and Conditions</li>
                                <li>Ad Quality</li>
                                <li><Link to='/frequently-asked-questions'>FAQ</Link></li>

                            </ul>
                        </div>

                    </div>

                    <div className='font-medium mt-12 lg:mt-0'>
                        <div className='space-y-1.5'>
                            <p className='font-medium'>CONTACT</p>
                            <p className='font-medium'>United States</p>
                            <ul className='list-disc ml-6'>
                                <li>Address: 220 Davidson Avenue, Sommerset NJ 08873</li>
                                <li>Phone: +1 732 788 3571</li>
                            </ul>
                            <p className='font-medium'>Singapore</p>
                            <ul className='list-disc ml-6'>
                                <li>Address: 160, Robinson Road #14-04.</li>
                                <li>Phone: +068 914</li>
                                <li><a href='mailto:info@dochase.com'>Email: info@dochase.com</a></li>
                            </ul>
                            <p className='font-medium'>Nigeria</p>
                            <ul className='list-disc ml-6'>
                                <li>Address: 361, Herbert Macaulay Way, Yaba Lagos -Nigeria.</li>
                                <li>Phone: +(234) 705 400 0728, +(234) 803 441 0381</li>
                                <li><a href='mailto:info@dochase.com'>Email: info@dochase.com</a></li>
                            </ul>
                            <p className='font-medium'>Kenya</p>
                            <ul className='list-disc ml-6'>
                                <li>Address: 220 Delta Corner annex Ring Road Westlands<br /> Lane, Westlands District</li>
                                <li>Phone: 00100 - G.P.O Nairobi</li>
                            </ul>

                        </div>
                    </div>
                </div>

            </div>
            <div className='pb-36 bg-[#343434]'>
                <div className='max-w-[1440px] mx-auto'>
                    <p className='pt-8 px-16 font-bold'>Copyright © dochase.com 2023</p>
                    <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696414376/dochaseadx/tv9dkboyj1lkocn3miox.svg' alt='DochaseAdx' className='float-right' loading='eager'/>
                </div>
            </div>
        </div>
    )
}

export default Footer